<div class="body">
<div class="download-card">
    <div class="file-name">{{fileName}}</div>
    <button (click)="downloadFile()" class="download-btn">⬇ Download</button>
  </div>
</div>